import type { BaseLogger } from "./types";

export const EMPTY_LOGGER: BaseLogger = {
  info: (..._arg) => {},
  warn: (..._arg) => {},
  error: (..._arg) => {},
  debug: (..._arg) => {},
};
